<script lang="ts">
  import {t} from '../i18n'
  import type {Collection} from '../types'
  import SearchInput from '../shared/SearchInput.svelte'
  import CollectionCard from './CollectionCard.svelte'
  import LoadMore from '../shared/LoadMore.svelte'
  import Placeholder from '../shared/Placeholder.svelte'
  import Dropdown from '../shared/Dropdown.svelte'
  import {modal} from '../stores/modal'
  import CollectionForm from './CollectionForm.svelte'

  export let url: string
  export let displayPlaceholder = false

  let collections: Collection[] | undefined
  let search = ''
  let order = 'recent'

  const orders = ['recent', 'popular']
  const orderOptions = orders.map(o => ({value: o, label: t.orders[o]}))

  $: displayedCollections = displayPlaceholder ? [{} as Collection, ...(collections || [])] : collections

  function onAdded(collection: Collection) {
    collections = [collection, ...(collections || [])]
  }

  function openNewCollection() {
    modal.show(CollectionForm, {props: {collection: {}, onSaved: onAdded}})
  }
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading with-filter inner-heading">
      <h2>{t.collections.title}</h2>

      <div class="right-filter">
        <SearchInput bind:search placeholder={t.collections.find}/>
        <Dropdown bind:value={order} options={orderOptions}/>
      </div>
    </div>

    {#if displayedCollections}
      <div class="grid three">
        {#each displayedCollections as collection}
          <div class="grid__item">
            {#if collection.id}
              <CollectionCard bind:collection/>
            {:else}
              <div class="grid__card collection__card--add">
                <div class="create__collection">
                  <span class="create__plus" onclick={openNewCollection}/>
                  <span class="create__collection-text">{t.collections.new.title}</span>
                </div>
              </div>
            {/if}
          </div>
        {/each}
      </div>
    {/if}

    {#if !displayedCollections || !displayedCollections.length}
      <Placeholder placeholder={t.placeholder.no_collections} loading={!displayedCollections}/>
    {/if}

    <LoadMore {url} {search} {order} bind:items={collections} per={12}/>
  </div>
</div>
